import { createStore, createEvent, combine, createEffect } from 'effector';
import { ApiUtils } from '@shared/utils';
import { DashboardApi, RequestStrategyEnum, type WithSignal, type DashboardItemsRequest, type ExpenseCategory } from '@shared/api';

const getExpenseCategoriesEffect = createEffect(({ signal, ...request }: WithSignal<DashboardItemsRequest>) =>
  DashboardApi.getExpenseCategories(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<ExpenseCategory[]>([])
  .on(getExpenseCategoriesEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getExpenseCategoriesEffect.pending, (_, data) => data)
  .on(getExpenseCategoriesEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getExpenseCategoriesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getExpenseCategoriesEffect, () => null)
  // .on(getExpenseCategoriesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getExpenseCategoriesEffect.fail, () => 'Something went wrong while fetching Expense categories. Please try again.')
  .on(getExpenseCategoriesEffect.done, () => null)
  .reset(clearEvent);

const getExpenseCategoriesApi = ApiUtils.wrapperApi(getExpenseCategoriesEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getExpenseCategoriesApi.cancel());

export const $dashboardExpenseCategoriesStore = {
  events: {
    getExpenseCategories: getExpenseCategoriesApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
